export const Filter = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7497 15.0004C29.7497 23.0016 23.2564 29.4882 15.2459 29.4882C7.23548 29.4882 0.742188 23.0016 0.742188 15.0004C0.742188 6.99934 7.23548 0.512695 15.2459 0.512695C23.2564 0.512695 29.7497 6.99934 29.7497 15.0004Z"
        fill="white"
        stroke="#E4E4E4"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2696 10.5595C12.2696 9.83067 11.7067 9.23733 11.0137 9.23733C10.3214 9.23733 9.75785 9.83067 9.75785 10.5595C9.75785 11.2883 10.3214 11.8817 11.0137 11.8817C11.7067 11.8817 12.2696 11.2883 12.2696 10.5595ZM13.379 10.5595C13.379 11.9323 12.3184 13.0497 11.0137 13.0497C9.70978 13.0497 8.64844 11.9323 8.64844 10.5595C8.64844 9.18672 9.70978 8.06934 11.0137 8.06934C12.3184 8.06934 13.379 9.18672 13.379 10.5595ZM21.222 10.5597C21.222 10.2373 20.9735 9.97566 20.6673 9.97566H16.1187C15.8125 9.97566 15.564 10.2373 15.564 10.5597C15.564 10.882 15.8125 11.1437 16.1187 11.1437H20.6673C20.9735 11.1437 21.222 10.882 21.222 10.5597ZM17.6007 18.3191C17.6007 19.0479 18.1635 19.6413 18.8565 19.6413C19.5495 19.6413 20.1124 19.0479 20.1124 18.3191C20.1124 17.5895 19.5495 16.9969 18.8565 16.9969C18.1635 16.9969 17.6007 17.5895 17.6007 18.3191ZM16.4912 18.3191C16.4912 16.9455 17.5518 15.8289 18.8565 15.8289C20.1612 15.8289 21.2218 16.9455 21.2218 18.3191C21.2218 19.6919 20.1612 20.8093 18.8565 20.8093C17.5518 20.8093 16.4912 19.6919 16.4912 18.3191ZM9.20366 17.7349H13.7515C14.0577 17.7349 14.3062 17.9965 14.3062 18.3189C14.3062 18.6412 14.0577 18.9029 13.7515 18.9029H9.20366C8.89746 18.9029 8.64896 18.6412 8.64896 18.3189C8.64896 17.9965 8.89746 17.7349 9.20366 17.7349Z"
        fill="#112347"
      />
      <rect
        x="7.64062"
        y="6.64258"
        width="14.5883"
        height="15.5925"
        rx="4.75"
        // stroke="#E4E4E4"
        // stroke-width="0.5"
      />
    </svg>
  );
};

export const Calendarimg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4.43245C7 4.27684 7 4.19903 6.9491 4.15423C6.89819 4.10944 6.82244 4.11915 6.67094 4.13857C5.54965 4.28229 4.76806 4.57508 4.17157 5.17157C3 6.34315 3 8.22876 3 12C3 15.7712 3 17.6569 4.17157 18.8284C5.34315 20 7.22876 20 11 20H13C16.7712 20 18.6569 20 19.8284 18.8284C21 17.6569 21 15.7712 21 12C21 8.22876 21 6.34315 19.8284 5.17157C19.2319 4.57508 18.4504 4.28229 17.3291 4.13857C17.1776 4.11915 17.1018 4.10944 17.0509 4.15424C17 4.19903 17 4.27684 17 4.43245L17 6.5C17 7.32843 16.3284 8 15.5 8C14.6716 8 14 7.32843 14 6.5L14 4.30005C14 4.15898 14 4.08844 13.9561 4.04451C13.9123 4.00059 13.8418 4.0005 13.7009 4.00031C13.4748 4 13.2412 4 13 4H11C10.7588 4 10.5252 4 10.2991 4.00031C10.1582 4.0005 10.0877 4.00059 10.0439 4.04452C10 4.08844 10 4.15898 10 4.30005L10 6.5C10 7.32843 9.32843 8 8.50001 8C7.67158 8 7 7.32843 7 6.5L7 4.43245Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path d="M8.5 2.5L8.5 6.5" stroke="white" stroke-linecap="round" />
      <path d="M15.5 2.5L15.5 6.5" stroke="white" stroke-linecap="round" />
      <circle cx="7.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="16.5" r="0.5" fill="white" />
    </svg>
  );
};

export const Line = () => {
  return (
    <div
      style={{
        borderLeft: '1.4px dashed #AF05FF', // Adjust the width and color as needed
        minHeight: '65px',
        height: '100%',
      }}
    ></div>
  );
};
export const FilterColor = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7499 14.9995C29.7499 23.0006 23.2566 29.4872 15.2462 29.4872C7.23572 29.4872 0.742432 23.0006 0.742432 14.9995C0.742432 6.99836 7.23572 0.511719 15.2462 0.511719C23.2566 0.511719 29.7499 6.99836 29.7499 14.9995Z"
        fill="blavk"
        stroke="#E4E4E4"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2674 10.5566C12.2674 9.82774 11.7045 9.2344 11.0115 9.2344C10.3192 9.2344 9.75565 9.82774 9.75565 10.5566C9.75565 11.2854 10.3192 11.8787 11.0115 11.8787C11.7045 11.8787 12.2674 11.2854 12.2674 10.5566ZM13.3768 10.5566C13.3768 11.9294 12.3162 13.0467 11.0115 13.0467C9.70758 13.0467 8.64624 11.9294 8.64624 10.5566C8.64624 9.18379 9.70758 8.06641 11.0115 8.06641C12.3162 8.06641 13.3768 9.18379 13.3768 10.5566ZM21.2198 10.5567C21.2198 10.2344 20.9713 9.97273 20.6651 9.97273H16.1165C15.8103 9.97273 15.5618 10.2344 15.5618 10.5567C15.5618 10.8791 15.8103 11.1407 16.1165 11.1407H20.6651C20.9713 11.1407 21.2198 10.8791 21.2198 10.5567ZM17.5985 18.3162C17.5985 19.045 18.1613 19.6383 18.8543 19.6383C19.5473 19.6383 20.1102 19.045 20.1102 18.3162C20.1102 17.5866 19.5473 16.994 18.8543 16.994C18.1613 16.994 17.5985 17.5866 17.5985 18.3162ZM16.489 18.3162C16.489 16.9426 17.5496 15.826 18.8543 15.826C20.159 15.826 21.2196 16.9426 21.2196 18.3162C21.2196 19.689 20.159 20.8063 18.8543 20.8063C17.5496 20.8063 16.489 19.689 16.489 18.3162ZM9.20146 17.7319H13.7493C14.0555 17.7319 14.304 17.9936 14.304 18.3159C14.304 18.6383 14.0555 18.8999 13.7493 18.8999H9.20146C8.89527 18.8999 8.64676 18.6383 8.64676 18.3159C8.64676 17.9936 8.89527 17.7319 9.20146 17.7319Z"
        fill="#3498db"
      />
      <rect
        x="7.63892"
        y="6.64062"
        width="14.5883"
        height="15.5925"
        rx="4.75"
        // stroke="#E4E4E4"
        // stroke-width="0.5"
      />
    </svg>
  );
};

export const Smallplus = () => {
  return (
    <svg
      width="40"
      height="39"
      viewBox="0 0 50 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.75" cy="24.5" r="24" fill="#FBFBFB" stroke="#D9D9D9" />
      <path
        d="M25.25 16V34"
        stroke="#666666"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 25H34.25"
        stroke="#666666"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Smallsearch = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="40"
      height="40"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="24" fill="#FBFBFB" stroke="#D9D9D9" />
      <g transform="translate(0, -3)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.1667 17.5C19.2444 17.5 15.1667 21.8119 15.1667 27.5C15.1667 33.1881 19.2444 37.5 24.1667 37.5C26.2333 37.5 28.1337 36.7093 29.5833 35.4833L33.6833 39.1667L33.7728 39.2344C34.1948 39.4654 34.7544 39.3986 35.0912 39.0822C35.4556 38.7349 35.528 38.1667 35.2807 37.75L31.1807 34.0667C32.783 32.046 33.8333 29.468 33.8333 27.5C33.8333 21.8119 29.7556 17.5 24.1667 17.5ZM24.1667 20.8333C27.5635 20.8333 30.1667 23.7398 30.1667 27.5C30.1667 31.2602 27.5635 34.1667 24.1667 34.1667C20.7698 34.1667 18.1667 31.2602 18.1667 27.5C18.1667 23.7398 20.7698 20.8333 24.1667 20.8333Z"
          fill="#666666"
        />
      </g>
    </svg>
  );
};

export const HeaderMessageIcon = ({ color }) => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.9952 3.86822L9.27421 3.86816C5.52737 3.86816 2.82422 6.89842 2.82422 10.7993V18.231C2.82422 22.1318 5.52737 25.1621 9.27421 25.1621H19.9852C21.7849 25.1419 23.4883 24.3838 24.7087 23.0641C25.9291 21.7445 26.56 19.9786 26.4544 18.1776L26.456 10.7993C26.56 9.05171 25.9291 7.28578 24.7087 5.96614C23.4883 4.6465 21.7849 3.88834 19.9952 3.86822ZM9.27468 5.67669L19.9757 5.67663C21.2748 5.69123 22.5112 6.24155 23.3971 7.19943C24.2829 8.15731 24.7408 9.43914 24.6642 10.7464L24.6626 18.2314C24.7408 19.5919 24.2829 20.8737 23.3971 21.8316C22.5112 22.7895 21.2748 23.3398 19.9757 23.3544L9.27468 23.3544C6.56356 23.3544 4.61852 21.174 4.61852 18.2314V10.7997C4.61852 7.8571 6.56356 5.67669 9.27468 5.67669ZM21.7659 10.5381C21.4564 10.1483 20.8919 10.0852 20.5052 10.3972L15.6593 14.307L15.5204 14.4046C14.949 14.7628 14.1987 14.7297 13.6514 14.2997L8.77006 10.3949L8.66019 10.3195C8.28159 10.0991 7.78988 10.1855 7.50994 10.541C7.20201 10.9321 7.26693 11.5008 7.65494 11.8112L12.5425 15.7209L12.7332 15.8606C13.9626 16.6986 15.5919 16.6522 16.7711 15.7258L21.6262 11.8088L21.7236 11.7177C22.0212 11.3949 22.0473 10.8924 21.7659 10.5381Z"
        fill={color}
      />
    </svg>
  );
};

export const Messageicon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.4238 3.33208L7.55465 3.33203C4.45499 3.33203 2.21875 5.83888 2.21875 9.06597V15.214C2.21875 18.4411 4.45499 20.9479 7.55465 20.9479H16.4156C17.9044 20.9312 19.3136 20.304 20.3232 19.2123C21.3328 18.1206 21.8547 16.6597 21.7674 15.1699L21.7687 9.06597C21.8547 7.62023 21.3328 6.15933 20.3232 5.06763C19.3136 3.97593 17.9044 3.34872 16.4238 3.33208ZM7.55411 4.82817L16.4067 4.82812C17.4814 4.8402 18.5043 5.29547 19.2372 6.0879C19.97 6.88032 20.3488 7.94074 20.2854 9.02218L20.2841 15.2143C20.3488 16.3399 19.97 17.4003 19.2372 18.1927C18.5043 18.9851 17.4814 19.4404 16.4067 19.4525L7.55411 19.4524C5.31127 19.4524 3.7022 17.6486 3.7022 15.2143V9.0663C3.7022 6.63196 5.31127 4.82817 7.55411 4.82817ZM17.8918 8.85128C17.6357 8.52881 17.1687 8.47663 16.8488 8.73475L12.8399 11.9692L12.725 12.05C12.2523 12.3463 11.6316 12.3189 11.1789 11.9632L7.14065 8.73281L7.04976 8.67046C6.73655 8.48811 6.32978 8.55958 6.09819 8.85372C5.84345 9.17727 5.89715 9.64771 6.21814 9.90448L10.2615 13.1389L10.4192 13.2544C11.4363 13.9477 12.7842 13.9094 13.7597 13.143L17.7762 9.90254L17.8567 9.82715C18.103 9.56007 18.1246 9.14444 17.8918 8.85128Z"
        fill={'#000000'}
      />
    </svg>
  );
};
export const Helpicon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_722_10819)">
        <path
          d="M28.8787 26.7107L26.9091 20.9786C27.8564 19.0636 28.3575 16.9291 28.3608 14.7813C28.3666 11.0828 26.9355 7.58561 24.3313 4.93418C21.7267 2.28225 18.2558 0.789544 14.5582 0.730874C12.621 0.699774 10.7412 1.05673 8.96817 1.79064C7.2581 2.49855 5.72454 3.52396 4.41015 4.83836C3.09569 6.15275 2.07028 7.68631 1.36242 9.39638C0.628511 11.1694 0.27195 13.0501 0.302602 14.9864C0.36116 18.684 1.85392 22.1549 4.50586 24.7596C7.15213 27.3587 10.6403 28.7893 14.3309 28.7892C14.3381 28.7892 14.3457 28.7892 14.353 28.7892C16.5007 28.7858 18.6352 28.2848 20.5503 27.3375L26.2824 29.3071C26.5029 29.3829 26.7288 29.4198 26.9523 29.4198C27.4832 29.4198 27.9996 29.2112 28.3912 28.8195C28.9476 28.2631 29.1345 27.4551 28.8787 26.7107ZM27.1884 27.6167C27.132 27.6732 27.0111 27.7588 26.8351 27.6984L20.7611 25.6112C20.6713 25.5804 20.5778 25.5651 20.4847 25.5651C20.3474 25.5651 20.2107 25.5983 20.087 25.6638C18.3315 26.5925 16.3478 27.0851 14.3503 27.0881C7.65108 27.0989 2.1095 21.6576 2.00337 14.9595C1.94997 11.5895 3.23186 8.42224 5.61292 6.04119C7.99397 3.66019 11.1603 2.37852 14.5312 2.43181C21.2293 2.538 26.6702 8.07683 26.6597 14.7787C26.6566 16.7763 26.1641 18.76 25.2354 20.5153C25.1255 20.7231 25.1065 20.9672 25.1829 21.1895L27.27 27.2635C27.3305 27.4394 27.2449 27.5604 27.1884 27.6167Z"
          fill="#112347"
        />
        <path
          d="M14.1911 21.0566C13.7462 21.0566 13.32 21.4478 13.3406 21.9072C13.3612 22.368 13.7143 22.7577 14.1911 22.7577C14.636 22.7577 15.0622 22.3665 15.0416 21.9072C15.021 21.4463 14.6679 21.0566 14.1911 21.0566Z"
          fill="#112347"
        />
        <path
          d="M14.1965 7.8833C11.8631 7.8833 9.96484 9.7816 9.96484 12.1149C9.96484 12.5846 10.3457 12.9654 10.8154 12.9654C11.2851 12.9654 11.6659 12.5846 11.6659 12.1149C11.6659 10.7196 12.8011 9.58435 14.1965 9.58435C15.5918 9.58435 16.727 10.7196 16.727 12.1149C16.727 13.5102 15.5918 14.6455 14.1965 14.6455C13.7268 14.6455 13.3459 15.0263 13.3459 15.496V18.965C13.3459 19.4347 13.7268 19.8155 14.1965 19.8155C14.6662 19.8155 15.047 19.4347 15.047 18.9649V16.2606C16.974 15.8658 18.4281 14.157 18.4281 12.1149C18.4281 9.7816 16.5298 7.8833 14.1965 7.8833Z"
          fill="#112347"
        />
      </g>
      <defs>
        <clipPath id="clip0_722_10819">
          <rect
            width="28.6908"
            height="28.6908"
            fill="white"
            transform="translate(0.300781 0.729492)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Homeicon = () => {
  return (
    <svg
      width="35px"
      height="35px"
      viewBox="0 -0.5 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.867 15.8321L18.873 10.0391L14.75 5.92908C13.5057 4.69031 11.4942 4.69031 10.25 5.92908L6.13599 10.0291V15.8291C6.1393 17.5833 7.56377 19.0028 9.31799 19.0001H15.685C17.438 19.0029 18.862 17.5851 18.867 15.8321Z"
        stroke="#000000"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.624 6.01807C19.624 5.60385 19.2882 5.26807 18.874 5.26807C18.4598 5.26807 18.124 5.60385 18.124 6.01807H19.624ZM18.874 10.0391H18.124C18.124 10.2384 18.2033 10.4295 18.3445 10.5702L18.874 10.0391ZM19.9705 12.1912C20.2638 12.4837 20.7387 12.4829 21.0311 12.1896C21.3236 11.8962 21.3229 11.4214 21.0295 11.1289L19.9705 12.1912ZM6.66552 10.5602C6.95886 10.2678 6.95959 9.79289 6.66714 9.49955C6.3747 9.20621 5.89982 9.20548 5.60648 9.49793L6.66552 10.5602ZM3.97048 11.1289C3.67714 11.4214 3.67641 11.8962 3.96886 12.1896C4.2613 12.4829 4.73618 12.4837 5.02952 12.1912L3.97048 11.1289ZM13.75 19.0001C13.75 19.4143 14.0858 19.7501 14.5 19.7501C14.9142 19.7501 15.25 19.4143 15.25 19.0001H13.75ZM9.75 19.0001C9.75 19.4143 10.0858 19.7501 10.5 19.7501C10.9142 19.7501 11.25 19.4143 11.25 19.0001H9.75ZM18.124 6.01807V10.0391H19.624V6.01807H18.124ZM18.3445 10.5702L19.9705 12.1912L21.0295 11.1289L19.4035 9.50792L18.3445 10.5702ZM5.60648 9.49793L3.97048 11.1289L5.02952 12.1912L6.66552 10.5602L5.60648 9.49793ZM15.25 19.0001V17.2201H13.75V19.0001H15.25ZM15.25 17.2201C15.25 15.7013 14.0188 14.4701 12.5 14.4701V15.9701C13.1904 15.9701 13.75 16.5297 13.75 17.2201H15.25ZM12.5 14.4701C10.9812 14.4701 9.75 15.7013 9.75 17.2201H11.25C11.25 16.5297 11.8096 15.9701 12.5 15.9701V14.4701ZM9.75 17.2201V19.0001H11.25V17.2201H9.75Z"
        fill="#000000"
      />
    </svg>
  );
};
export const BellIcon = () => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0391 0.667969H9.96181C6.31191 0.667969 2.96538 3.31625 2.64071 6.82234C2.61906 7.07315 2.6043 7.32945 2.59477 7.60554L2.58143 8.25102L2.57879 8.82975L2.59509 8.76378C2.44446 9.49827 2.09731 10.1796 1.58954 10.7362L1.51677 10.8299C1.082 11.4903 0.832189 12.2548 0.793521 13.0442L0.792605 13.3023C0.770409 14.3405 1.12618 15.3679 1.79547 16.1838C2.7031 17.1421 3.878 17.7138 5.139 17.8351C8.36412 18.1853 11.6271 18.1853 14.8612 17.8342C16.1136 17.7189 17.292 17.1456 18.1616 16.2227C18.8182 15.4372 19.1765 14.4945 19.2072 13.5185L19.2083 13.0816C19.1724 12.2575 18.921 11.4923 18.481 10.8347L18.4141 10.7489L18.2509 10.5569C17.884 10.0987 17.6161 9.57083 17.4637 9.00626L17.4154 8.80355L17.4054 8.59096C17.4024 8.49534 17.4009 8.38932 17.4005 8.25689L17.4003 7.5277C17.3978 7.24876 17.3895 7.05041 17.3703 6.82711C17.0345 3.31439 13.687 0.667969 10.0391 0.667969ZM9.96181 2.1796H10.0391C12.9614 2.1796 15.6272 4.28712 15.8833 6.96567C15.8984 7.14152 15.9052 7.30928 15.9072 7.55851L15.9101 8.53853C15.9134 8.69527 15.9195 8.82561 15.93 8.97227L15.944 9.07266L16.0143 9.37143C16.2226 10.1618 16.5967 10.8991 17.1117 11.5347L17.2611 11.7099L17.2446 11.6824C17.5302 12.1093 17.693 12.6047 17.7157 13.1156L17.715 13.2927C17.7322 14.0034 17.4966 14.6788 17.0507 15.2135C16.4615 15.8368 15.6193 16.2466 14.7139 16.33C11.5737 16.6708 8.41752 16.6708 5.28928 16.3312C4.37402 16.2431 3.53118 15.833 2.90812 15.1771C2.50423 14.6816 2.27112 14.0084 2.28575 13.3185L2.28592 13.0816L2.30485 12.8752C2.35043 12.5299 2.46579 12.18 2.64461 11.8578L2.73529 11.7077C3.40007 10.96 3.85629 10.0509 4.05723 9.07103L4.07282 8.9174L4.07989 7.92152L4.09728 7.41627C4.10517 7.25688 4.11527 7.10544 4.12794 6.95864C4.37533 4.28724 7.03868 2.1796 9.96181 2.1796ZM2.73529 11.7077C2.71922 11.7258 2.70302 11.7438 2.68669 11.7617L2.74007 11.6998L2.73529 11.7077ZM12.8252 19.8328C12.5039 19.5711 12.0339 19.6227 11.7755 19.9479C11.6634 20.0889 11.5337 20.2153 11.3894 20.3242C10.8999 20.7081 10.2891 20.8791 9.68189 20.8067C9.07554 20.7345 8.52437 20.4259 8.15039 19.9507C7.89343 19.6243 7.42367 19.5704 7.10115 19.8306C6.77863 20.0907 6.72547 20.5662 6.98243 20.8927C7.60255 21.6806 8.51122 22.1894 9.50737 22.308C10.5026 22.4266 11.5048 22.1461 12.2931 21.5276C12.5271 21.3512 12.7479 21.1359 12.939 20.8955C13.1975 20.5702 13.1465 20.0945 12.8252 19.8328Z"
        fill="#666666"
      />
    </svg>
  );
};

export const BellColorIcon = () => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0391 0.667969H9.96181C6.31191 0.667969 2.96538 3.31625 2.64071 6.82234C2.61906 7.07315 2.6043 7.32945 2.59477 7.60554L2.58143 8.25102L2.57879 8.82975L2.59509 8.76378C2.44446 9.49827 2.09731 10.1796 1.58954 10.7362L1.51677 10.8299C1.082 11.4903 0.832189 12.2548 0.793521 13.0442L0.792605 13.3023C0.770409 14.3405 1.12618 15.3679 1.79547 16.1838C2.7031 17.1421 3.878 17.7138 5.139 17.8351C8.36412 18.1853 11.6271 18.1853 14.8612 17.8342C16.1136 17.7189 17.292 17.1456 18.1616 16.2227C18.8182 15.4372 19.1765 14.4945 19.2072 13.5185L19.2083 13.0816C19.1724 12.2575 18.921 11.4923 18.481 10.8347L18.4141 10.7489L18.2509 10.5569C17.884 10.0987 17.6161 9.57083 17.4637 9.00626L17.4154 8.80355L17.4054 8.59096C17.4024 8.49534 17.4009 8.38932 17.4005 8.25689L17.4003 7.5277C17.3978 7.24876 17.3895 7.05041 17.3703 6.82711C17.0345 3.31439 13.687 0.667969 10.0391 0.667969ZM9.96181 2.1796H10.0391C12.9614 2.1796 15.6272 4.28712 15.8833 6.96567C15.8984 7.14152 15.9052 7.30928 15.9072 7.55851L15.9101 8.53853C15.9134 8.69527 15.9195 8.82561 15.93 8.97227L15.944 9.07266L16.0143 9.37143C16.2226 10.1618 16.5967 10.8991 17.1117 11.5347L17.2611 11.7099L17.2446 11.6824C17.5302 12.1093 17.693 12.6047 17.7157 13.1156L17.715 13.2927C17.7322 14.0034 17.4966 14.6788 17.0507 15.2135C16.4615 15.8368 15.6193 16.2466 14.7139 16.33C11.5737 16.6708 8.41752 16.6708 5.28928 16.3312C4.37402 16.2431 3.53118 15.833 2.90812 15.1771C2.50423 14.6816 2.27112 14.0084 2.28575 13.3185L2.28592 13.0816L2.30485 12.8752C2.35043 12.5299 2.46579 12.18 2.64461 11.8578L2.73529 11.7077C3.40007 10.96 3.85629 10.0509 4.05723 9.07103L4.07282 8.9174L4.07989 7.92152L4.09728 7.41627C4.10517 7.25688 4.11527 7.10544 4.12794 6.95864C4.37533 4.28724 7.03868 2.1796 9.96181 2.1796ZM2.73529 11.7077C2.71922 11.7258 2.70302 11.7438 2.68669 11.7617L2.74007 11.6998L2.73529 11.7077ZM12.8252 19.8328C12.5039 19.5711 12.0339 19.6227 11.7755 19.9479C11.6634 20.0889 11.5337 20.2153 11.3894 20.3242C10.8999 20.7081 10.2891 20.8791 9.68189 20.8067C9.07554 20.7345 8.52437 20.4259 8.15039 19.9507C7.89343 19.6243 7.42367 19.5704 7.10115 19.8306C6.77863 20.0907 6.72547 20.5662 6.98243 20.8927C7.60255 21.6806 8.51122 22.1894 9.50737 22.308C10.5026 22.4266 11.5048 22.1461 12.2931 21.5276C12.5271 21.3512 12.7479 21.1359 12.939 20.8955C13.1975 20.5702 13.1465 20.0945 12.8252 19.8328Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export const Cancelicon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.41421"
        y1="1"
        x2="15"
        y2="14.5858"
        stroke="#AEAAB5"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="1"
        y1="14.5858"
        x2="14.5858"
        y2="1"
        stroke="#AEAAB5"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const Owner = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.16 10.87C12.06 10.86 11.94 10.86 11.83 10.87C9.45 10.79 7.56 8.84 7.56 6.44C7.56 3.99 9.54 2 12 2C14.45 2 16.44 3.99 16.44 6.44C16.43 8.84 14.54 10.79 12.16 10.87Z"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.16 14.56C4.74 16.18 4.74 18.82 7.16 20.43C9.91 22.27 14.42 22.27 17.17 20.43C19.59 18.81 19.59 16.17 17.17 14.56C14.43 12.73 9.92 12.73 7.16 14.56Z"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Buyer = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5 19.5H14.5"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 21.5V17.5"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.16 10.87C12.06 10.86 11.94 10.86 11.83 10.87C9.45 10.79 7.56 8.84 7.56 6.44C7.55 3.99 9.54 2 11.99 2C14.44 2 16.43 3.99 16.43 6.44C16.43 8.84 14.53 10.79 12.16 10.87Z"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.99 21.81C10.17 21.81 8.35999 21.35 6.97999 20.43C4.55999 18.81 4.55999 16.17 6.97999 14.56C9.72999 12.72 14.24 12.72 16.99 14.56"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Home = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2452 21.2807H7.86716C6.91971 21.3145 5.99664 20.9875 5.29853 20.3706C4.60041 19.7538 4.18365 18.897 4.13879 17.9864V13.6678C4.13879 13.4842 4.21463 13.3082 4.34961 13.1784C4.48459 13.0486 4.66766 12.9757 4.85856 12.9757C5.04945 12.9757 5.23252 13.0486 5.36751 13.1784C5.50249 13.3082 5.57832 13.4842 5.57832 13.6678V17.9864C5.62256 18.53 5.88741 19.035 6.31567 19.3924C6.74393 19.7498 7.30122 19.9309 7.86716 19.8965H16.2452C16.8111 19.9309 17.3684 19.7498 17.7967 19.3924C18.2249 19.035 18.4898 18.53 18.534 17.9864V13.6678C18.534 13.4842 18.6099 13.3082 18.7449 13.1784C18.8798 13.0486 19.0629 12.9757 19.2538 12.9757C19.4447 12.9757 19.6278 13.0486 19.7627 13.1784C19.8977 13.3082 19.9736 13.4842 19.9736 13.6678V17.9864C19.9287 18.897 19.5119 19.7538 18.8138 20.3706C18.1157 20.9875 17.1926 21.3145 16.2452 21.2807ZM21.9241 12.0829C21.9916 12.0186 22.0451 11.9421 22.0817 11.8577C22.1182 11.7734 22.137 11.6829 22.137 11.5916C22.137 11.5002 22.1182 11.4097 22.0817 11.3254C22.0451 11.2411 21.9916 11.1645 21.9241 11.1002L12.5672 2.10315C12.5003 2.03829 12.4207 1.9868 12.333 1.95166C12.2453 1.91653 12.1512 1.89844 12.0562 1.89844C11.9612 1.89844 11.8671 1.91653 11.7794 1.95166C11.6917 1.9868 11.6121 2.03829 11.5451 2.10315L2.18824 11.1002C2.0527 11.2305 1.97656 11.4073 1.97656 11.5916C1.97656 11.7759 2.0527 11.9526 2.18824 12.0829C2.32377 12.2133 2.5076 12.2865 2.69927 12.2865C2.89094 12.2865 3.07477 12.2133 3.2103 12.0829L12.0562 3.57036L20.9021 12.0829C20.969 12.1478 21.0486 12.1993 21.1363 12.2344C21.224 12.2696 21.3181 12.2876 21.4131 12.2876C21.5081 12.2876 21.6022 12.2696 21.6899 12.2344C21.7776 12.1993 21.8572 12.1478 21.9241 12.0829Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
    </svg>
  );
};
export const Property = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6068 2.01193C14.5637 2.00423 14.5193 2.00021 14.474 2.00021C14.4287 2.00021 14.3843 2.00423 14.3412 2.01193H8.08377C5.59647 2.01193 3.49977 4.02976 3.49977 6.49093V17.2039C3.49977 19.8045 5.50437 21.8649 8.08377 21.8649H16.0728C18.5261 21.8649 20.5518 19.703 20.5518 17.2039V8.03793C20.5518 7.84432 20.4769 7.6582 20.3428 7.51853L15.2778 2.24253C15.1364 2.09521 14.941 2.01193 14.7368 2.01193H14.6068ZM13.724 3.51113L8.08368 3.51193C6.41221 3.51193 4.99968 4.87133 4.99968 6.49093V17.2039C4.99968 18.9852 6.34206 20.3649 8.08368 20.3649H16.0727C17.6749 20.3649 19.0517 18.8956 19.0517 17.2039L19.051 8.9833L18.1756 8.98628C17.842 8.98588 17.4624 8.98517 17.0404 8.98421C15.2709 8.98047 13.8268 7.5935 13.7293 5.8476L13.724 5.65921V3.51113ZM18.2302 7.48405L17.0437 7.48422C16.0383 7.48209 15.224 6.66567 15.224 5.65921V4.35274L18.2302 7.48405ZM14.2841 14.8078C14.6983 14.8078 15.0341 15.1436 15.0341 15.5578C15.0341 15.9375 14.752 16.2513 14.3859 16.301L14.2841 16.3078H8.88712C8.47291 16.3078 8.13712 15.972 8.13712 15.5578C8.13712 15.1781 8.41928 14.8643 8.78535 14.8147L8.88712 14.8078H14.2841ZM12.9926 10.6056C12.9926 10.1914 12.6568 9.85561 12.2426 9.85561H8.88661L8.78483 9.86246C8.41876 9.91212 8.13661 10.2259 8.13661 10.6056C8.13661 11.0198 8.47239 11.3556 8.88661 11.3556H12.2426L12.3444 11.3488C12.7104 11.2991 12.9926 10.9853 12.9926 10.6056Z"
        fill="#666666"
      />
    </svg>
  );
};
export const Appraisal = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17692_95378)">
        <path
          d="M21.0001 8.34562V2.25C21.0001 2.04262 20.8321 1.875 20.6251 1.875H16.8751C16.6681 1.875 16.5001 2.04262 16.5001 2.25V4.29562L12.251 0.471375C12.1824 0.4095 12.0931 0.375 12.0001 0.375C11.8561 0.375 11.8561 0.375 6.12425 5.53387L0.499247 10.5964C0.422747 10.665 0.377747 10.7621 0.375122 10.8653C0.372497 10.968 0.412247 11.0674 0.484622 11.1401L1.60962 12.2651C1.75025 12.405 1.97562 12.4121 2.12412 12.2801L3.00012 11.5016V23.25C3.00012 23.4574 3.16812 23.625 3.37512 23.625H19.8751V23.6081C19.9332 23.6138 19.9902 23.625 20.0491 23.625C20.987 23.625 21.7501 22.8622 21.7501 21.9244C21.7501 21.4702 21.5731 21.0427 21.2517 20.7218L21.0001 20.4697V11.5016L21.8757 12.2801C21.947 12.3435 22.0362 12.375 22.1251 12.375C22.2211 12.375 22.3175 12.3379 22.3902 12.2651L23.5152 11.1401C23.588 11.0674 23.6277 10.968 23.6247 10.8653C23.6221 10.7625 23.5775 10.6654 23.5006 10.5964L21.0001 8.34562ZM17.2501 2.625H20.2501V7.67062L17.2501 4.97062V2.625ZM20.0491 22.875C19.7949 22.875 19.5564 22.776 19.3767 22.5968L16.2804 19.5L17.6251 18.1553L20.7215 21.252C20.9011 21.4316 21.0001 21.6705 21.0001 21.9244C21.0001 22.4482 20.5734 22.875 20.0491 22.875ZM12.0001 18.375C9.51875 18.375 7.50012 16.3564 7.50012 13.875C7.50012 11.3936 9.51875 9.375 12.0001 9.375C14.4815 9.375 16.5001 11.3936 16.5001 13.875C16.5001 16.3564 14.4815 18.375 12.0001 18.375ZM15.9939 17.274L16.7199 18L16.1251 18.5947L15.3991 17.8688C15.6129 17.6865 15.8116 17.4877 15.9939 17.274ZM20.2501 19.7197L17.8902 17.3599C17.7496 17.2192 17.5006 17.2192 17.36 17.3599L17.2501 17.4697L16.4416 16.6613C16.9509 15.8527 17.2501 14.8991 17.2501 13.875C17.2501 10.98 14.8951 8.625 12.0001 8.625C9.10512 8.625 6.75012 10.98 6.75012 13.875C6.75012 16.77 9.10512 19.125 12.0001 19.125C13.0242 19.125 13.9779 18.8258 14.7864 18.3165L15.5949 19.125L15.485 19.2349C15.3384 19.3815 15.3384 19.6185 15.485 19.7651L18.5949 22.875H3.75012V10.8349L12.0001 3.50175L20.2501 10.8349V19.7197ZM22.1097 11.4847L12.2495 2.71987C12.1074 2.59312 11.8932 2.59312 11.7511 2.71987L1.8905 11.4847L1.295 10.8892C2.89212 9.45187 10.5166 2.58975 12.0001 1.25475L22.7052 10.8892L22.1097 11.4847Z"
          fill="#666666"
        />
        <path
          d="M12 10.125C9.93225 10.125 8.25 11.8073 8.25 13.875C8.25 15.9427 9.93225 17.625 12 17.625C14.0677 17.625 15.75 15.9427 15.75 13.875C15.75 11.8073 14.0677 10.125 12 10.125ZM12 16.875C10.3459 16.875 9 15.5291 9 13.875C9 12.2209 10.3459 10.875 12 10.875C13.6541 10.875 15 12.2209 15 13.875C15 15.5291 13.6541 16.875 12 16.875Z"
          fill="#666666"
        />
        <path
          d="M12 12.75C12.2066 12.75 12.375 12.918 12.375 13.125H13.125C13.125 12.6367 12.8104 12.2242 12.375 12.069V11.625H11.625V12.069C11.1896 12.2242 10.875 12.6367 10.875 13.125C10.875 13.7452 11.3798 14.25 12 14.25C12.2066 14.25 12.375 14.418 12.375 14.625C12.375 14.832 12.2066 15 12 15C11.7934 15 11.625 14.832 11.625 14.625H10.875C10.875 15.1133 11.1896 15.5258 11.625 15.681V16.125H12.375V15.681C12.8104 15.5258 13.125 15.1133 13.125 14.625C13.125 14.0048 12.6202 13.5 12 13.5C11.7934 13.5 11.625 13.332 11.625 13.125C11.625 12.918 11.7934 12.75 12 12.75Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_17692_95378">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Campaign = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9949 5.87002C12.8604 5.87203 12.7311 5.92007 12.6305 6.00542C12.5298 6.09077 12.4645 6.20779 12.4463 6.33527C11.8969 6.54934 11.5035 7.06592 11.5035 7.66374C11.5035 8.08227 11.7148 8.44741 11.9613 8.68322C12.2079 8.91902 12.48 9.06718 12.7144 9.20171C12.9488 9.33624 13.1455 9.45714 13.2506 9.55765C13.3557 9.65817 13.3788 9.69662 13.3788 9.8162C13.3788 10.0207 13.2175 10.1749 13.0037 10.1749C12.7899 10.1749 12.6287 10.0207 12.6287 9.8162C12.6297 9.74489 12.6159 9.6741 12.5881 9.60793C12.5603 9.54176 12.5191 9.48153 12.4667 9.43075C12.4144 9.37997 12.352 9.33964 12.2832 9.31212C12.2144 9.28459 12.1406 9.27042 12.0661 9.27042C11.9915 9.27042 11.9177 9.28459 11.8489 9.31212C11.7802 9.33964 11.7178 9.37997 11.6654 9.43075C11.6131 9.48153 11.5718 9.54176 11.544 9.60793C11.5162 9.6741 11.5025 9.74489 11.5035 9.8162C11.5035 10.4142 11.8973 10.9308 12.447 11.1447C12.466 11.2731 12.5328 11.3906 12.6352 11.4756C12.7375 11.5606 12.8685 11.6074 13.0041 11.6074C13.1396 11.6074 13.2706 11.5606 13.373 11.4756C13.4753 11.3906 13.5422 11.2731 13.5612 11.1447C14.1105 10.9306 14.5039 10.414 14.5039 9.8162C14.5039 9.39767 14.2926 9.03253 14.0461 8.79672C13.7996 8.56092 13.5275 8.41276 13.2931 8.27823C13.0586 8.1437 12.8619 8.0228 12.7568 7.92229C12.6518 7.82177 12.6287 7.78332 12.6287 7.66374C12.6287 7.45924 12.7899 7.30499 13.0037 7.30499C13.2175 7.30499 13.3788 7.45924 13.3788 7.66374C13.3777 7.73505 13.3915 7.80584 13.4193 7.87201C13.4471 7.93818 13.4883 7.99841 13.5407 8.04919C13.593 8.09997 13.6554 8.1403 13.7242 8.16782C13.793 8.19534 13.8668 8.20952 13.9413 8.20952C14.0159 8.20952 14.0897 8.19534 14.1585 8.16782C14.2273 8.1403 14.2896 8.09997 14.342 8.04919C14.3943 7.99841 14.4356 7.93818 14.4634 7.87201C14.4912 7.80584 14.505 7.73505 14.5039 7.66374C14.5039 7.06569 14.1101 6.54918 13.5604 6.33527C13.5418 6.20504 13.474 6.08583 13.3699 6.00012C13.2657 5.91442 13.1323 5.86814 12.9949 5.87002V5.87002Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M13.0016 3C9.69412 3 7.00081 5.57621 7.00081 8.7399C7.00081 9.91982 7.38075 11.0714 8.08933 12.0373C8.1318 12.0951 8.18577 12.1445 8.24817 12.1824C8.31056 12.2203 8.38015 12.2461 8.45297 12.2583C8.52579 12.2705 8.60041 12.2689 8.67257 12.2535C8.74472 12.2381 8.81301 12.2093 8.87352 12.1687C8.93403 12.128 8.98558 12.0764 9.02523 12.0167C9.06487 11.957 9.09185 11.8905 9.1046 11.8208C9.11735 11.7512 9.11563 11.6798 9.09955 11.6108C9.08346 11.5418 9.05332 11.4764 9.01084 11.4186C8.43505 10.6337 8.12596 9.69869 8.12596 8.7399C8.12596 6.15785 10.3022 4.07623 13.0016 4.07623C15.701 4.07623 17.8773 6.15785 17.8773 8.7399C17.8773 11.3219 15.701 13.4036 13.0016 13.4036C11.9991 13.4036 11.021 13.1081 10.2005 12.5572C10.1401 12.5142 10.0714 12.4833 9.99836 12.4662C9.92532 12.4492 9.84944 12.4462 9.77521 12.4577C9.70098 12.4691 9.62989 12.4947 9.56616 12.5329C9.50243 12.571 9.44734 12.621 9.40415 12.6799C9.36096 12.7388 9.33055 12.8053 9.31471 12.8756C9.29887 12.9459 9.29792 13.0186 9.31193 13.0892C9.32593 13.1599 9.3546 13.2272 9.39624 13.2871C9.43789 13.3469 9.49166 13.3982 9.55437 13.4379C10.5642 14.1159 11.7678 14.4798 13.0016 14.4798C16.3091 14.4798 19.0024 11.9036 19.0024 8.7399C19.0024 5.57621 16.3091 3 13.0016 3V3Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M1.56258 12.6862C1.25189 12.6862 1.00003 12.9271 1 13.2243V21.1166C1.00003 21.4138 1.25189 21.6547 1.56258 21.6548H4.18793C4.49862 21.6547 4.75047 21.4138 4.7505 21.1166V14.8386H6.43823C6.61384 14.8386 7.38947 15.1296 8.04538 15.4839C9.02016 16.0091 9.32114 16.2505 9.66058 16.3325C10.6683 16.605 12.1036 16.5832 13.3818 16.7746C13.5137 16.9484 13.5653 17.1358 13.5876 17.3498H10.0532C9.29243 17.3395 9.29243 18.4364 10.0532 18.4261H14.2044C14.5103 18.4261 14.7602 18.1924 14.767 17.8999C14.7514 16.7963 14.4516 15.8637 13.5466 15.7117C12.1444 15.5017 10.4939 15.4615 9.96678 15.2969C9.78714 15.2408 9.10493 14.8094 8.59916 14.5472C7.90541 14.1723 7.20024 13.7624 6.43823 13.7624H4.18793C3.84403 13.7624 3.62535 14.0369 3.62535 14.3005V20.5785H2.12515V13.7624H2.68773C3.44851 13.7727 3.44851 12.6759 2.68773 12.6862H1.56258Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M20.7298 16.0337C19.455 16.1444 17.378 16.5909 15.8644 16.9369C15.1249 17.0977 15.3903 18.16 16.126 17.9837C17.5787 17.6516 19.5641 17.23 20.6918 17.1175C20.8043 17.2922 20.8309 17.3744 20.8632 17.5215C18.4297 18.4243 14.7148 20.1287 14.5474 20.2055L7.92466 20.5747C7.37107 20.4174 6.79959 20.1702 6.34315 19.975C5.61058 19.7043 5.22458 20.6989 5.90657 20.9657C6.46569 21.2089 7.08704 21.4599 7.51592 21.5837C7.63707 21.618 7.7839 21.6589 7.97008 21.6524L14.721 21.2733C14.7939 21.2693 14.8653 21.2516 14.9312 21.2215C14.9312 21.2215 19.1008 19.3117 21.4675 18.4517C22.5838 18.0231 21.7537 15.9157 20.7298 16.0337V16.0337Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
    </svg>
  );
};
export const Addicon = () => {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.5" cy="24.5" r="24" fill="#FBFBFB" stroke="#D9D9D9" />
      <path
        d="M25 16V34"
        stroke="#112347"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 25H34"
        stroke="#112347"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Addrotateicon = () => {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 50"
      transform="rotate(315 0 0)"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.5" cy="24.5" r="24" fill="#FBFBFB" stroke="#D9D9D9" />
      <path
        d="M25 16V34"
        stroke="#112347"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 25H34"
        stroke="#112347"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SmallAddrotateicon = () => {
  return (
    <svg
      width="40"
      height="39"
      viewBox="0 0 50 49"
      transform="rotate(315 0 0)"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.5" cy="24.5" r="24" fill="#FBFBFB" stroke="#D9D9D9" />
      <path
        d="M25 16V34"
        stroke="#666666"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 25H34"
        stroke="#666666"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Setting = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="5" fill="#6C2AD2" fill-opacity="0.1" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.9838 6.54161C18.0711 6.71093 18.0928 6.92777 18.1361 7.36144C18.2182 8.1823 18.2593 8.59274 18.4311 8.81793C18.649 9.10358 19.0034 9.25038 19.3595 9.20248C19.6402 9.16472 19.9594 8.90352 20.5979 8.38113C20.9352 8.10515 21.1038 7.96716 21.2853 7.90918C21.5158 7.83555 21.7652 7.84798 21.9872 7.94419C22.162 8.01994 22.3161 8.17402 22.6243 8.4822L23.5178 9.37567C23.8259 9.68385 23.98 9.83794 24.0558 10.0128C24.152 10.2348 24.1644 10.4841 24.0908 10.7146C24.0328 10.8961 23.8948 11.0648 23.6188 11.4021C23.0964 12.0406 22.8352 12.3598 22.7975 12.6406C22.7496 12.9966 22.8964 13.351 23.182 13.5689C23.4072 13.7407 23.8176 13.7818 24.6385 13.8639C25.0722 13.9072 25.2891 13.9289 25.4584 14.0162C25.6734 14.1272 25.841 14.3123 25.9299 14.5373C26 14.7145 26 14.9324 26 15.3682V16.6319C26 17.0676 26 17.2855 25.93 17.4626C25.841 17.6877 25.6734 17.8729 25.4583 17.9838C25.289 18.0711 25.0722 18.0928 24.6386 18.1361L24.6386 18.1361C23.818 18.2182 23.4077 18.2592 23.1825 18.4309C22.8967 18.6489 22.7499 19.0034 22.7979 19.3596C22.8357 19.6402 23.0968 19.9593 23.619 20.5976C23.8949 20.9348 24.0328 21.1034 24.0908 21.2848C24.1645 21.5154 24.152 21.7648 24.0558 21.9869C23.98 22.1617 23.826 22.3157 23.5179 22.6238L22.6243 23.5174C22.3162 23.8255 22.1621 23.9796 21.9873 24.0554C21.7652 24.1516 21.5159 24.164 21.2854 24.0904C21.1039 24.0324 20.9352 23.8944 20.5979 23.6184L20.5979 23.6184C19.9594 23.096 19.6402 22.8348 19.3595 22.7971C19.0034 22.7492 18.649 22.896 18.4311 23.1816C18.2593 23.4068 18.2183 23.8173 18.1362 24.6383C18.0928 25.0722 18.0711 25.2891 17.9837 25.4585C17.8728 25.6735 17.6877 25.8409 17.4628 25.9299C17.2856 26 17.0676 26 16.6316 26H15.3682C14.9324 26 14.7145 26 14.5373 25.9299C14.3123 25.841 14.1272 25.6734 14.0162 25.4584C13.9289 25.2891 13.9072 25.0722 13.8639 24.6385C13.7818 23.8176 13.7407 23.4072 13.5689 23.182C13.351 22.8964 12.9966 22.7496 12.6406 22.7975C12.3599 22.8352 12.0406 23.0964 11.4021 23.6189L11.4021 23.6189C11.0647 23.8949 10.8961 24.0329 10.7146 24.0908C10.4841 24.1645 10.2347 24.152 10.0127 24.0558C9.8379 23.9801 9.6838 23.826 9.37561 23.5178L8.48217 22.6243C8.17398 22.3162 8.01988 22.1621 7.94414 21.9873C7.84794 21.7652 7.8355 21.5159 7.90913 21.2854C7.96711 21.1039 8.10511 20.9352 8.3811 20.5979C8.90351 19.9594 9.16471 19.6402 9.20247 19.3594C9.25037 19.0034 9.10357 18.649 8.81792 18.4311C8.59273 18.2593 8.1823 18.2182 7.36143 18.1361C6.92776 18.0928 6.71093 18.0711 6.54161 17.9838C6.32656 17.8728 6.15902 17.6877 6.07005 17.4627C6 17.2855 6 17.0676 6 16.6318V15.3683C6 14.9324 6 14.7144 6.07008 14.5372C6.15905 14.3123 6.32654 14.1272 6.54152 14.0163C6.71088 13.9289 6.92777 13.9072 7.36155 13.8638H7.36155H7.36156C8.18264 13.7817 8.59319 13.7407 8.81842 13.5688C9.10395 13.3509 9.2507 12.9966 9.20287 12.6407C9.16514 12.3599 8.90385 12.0405 8.38128 11.4018C8.10516 11.0643 7.96711 10.8956 7.90914 10.7141C7.83557 10.4836 7.848 10.2344 7.94413 10.0124C8.01988 9.83754 8.17403 9.68339 8.48233 9.37509L9.37565 8.48177L9.37566 8.48177C9.68385 8.17357 9.83795 8.01947 10.0128 7.94373C10.2348 7.84753 10.4841 7.8351 10.7146 7.90872C10.8961 7.9667 11.0648 8.10472 11.4022 8.38076C12.0406 8.9031 12.3598 9.16427 12.6404 9.20207C12.9966 9.25003 13.3511 9.10319 13.5691 8.81742C13.7408 8.59227 13.7818 8.18195 13.8639 7.36131C13.9072 6.92776 13.9289 6.71098 14.0162 6.5417C14.1271 6.32658 14.3123 6.15898 14.5374 6.07001C14.7145 6 14.9324 6 15.3681 6H16.6318C17.0676 6 17.2855 6 17.4627 6.07005C17.6877 6.15902 17.8728 6.32656 17.9838 6.54161ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
export const Phone = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.85742 10.6484C5.85742 10.821 5.71753 10.9609 5.54492 10.9609C5.37231 10.9609 5.23242 10.821 5.23242 10.6484C5.23242 10.476 5.37231 10.3359 5.54492 10.3359C5.71753 10.3359 5.85742 10.476 5.85742 10.6484Z"
        fill="#6C2AD2"
      />
      <path
        d="M9.56351 14.8688C10.9865 15.5662 12.6984 15.276 13.8236 14.1508L14.4698 13.5047C14.8206 13.1542 14.8207 12.5865 14.4699 12.2358L11.9733 9.73943C11.6231 9.38872 11.0552 9.38823 10.7046 9.7393L9.64383 10.8002C9.43607 11.008 9.11539 11.0503 8.8815 10.901C8.50016 10.6573 8.12919 10.3885 7.77897 10.1021C7.6453 9.99284 7.44852 10.0126 7.33927 10.1462C7.23002 10.2798 7.24979 10.4767 7.38334 10.5859C7.75235 10.8876 8.1431 11.1708 8.54508 11.4277C9.02421 11.7337 9.67215 11.6557 10.0857 11.2421L11.1468 10.1811C11.2528 10.0749 11.4247 10.0746 11.5313 10.1812L14.028 12.6777C14.1343 12.7841 14.1346 12.9562 14.028 13.0625L13.3817 13.7089C12.4444 14.6463 11.0205 14.8869 9.83854 14.3077C5.50834 12.1842 3.15238 8.81731 1.93851 6.36662C1.35782 5.19463 1.59891 3.77617 2.53849 2.83684L3.17057 2.20488C3.27652 2.09868 3.44852 2.09831 3.55497 2.205L6.05191 4.70183C6.15763 4.80742 6.15873 4.97954 6.05167 5.08635L4.99088 6.14726C4.57731 6.56084 4.4993 7.20879 4.80533 7.68803C4.98563 7.97014 5.17997 8.24846 5.38309 8.51518C5.48758 8.65251 5.68363 8.679 5.82096 8.57451C5.95829 8.47002 5.9849 8.27397 5.88028 8.13652C5.68766 7.88347 5.50309 7.61931 5.33194 7.35161C5.18265 7.1176 5.22501 6.79692 5.43277 6.58916L6.49344 5.52849C6.84415 5.17827 6.84452 4.61028 6.49369 4.25981L3.99698 1.76323C3.64689 1.41252 3.07889 1.41203 2.72843 1.76311L2.09659 2.39494C0.967198 3.52397 0.678624 5.23161 1.37845 6.64409C2.63541 9.18156 5.0756 12.6681 9.56351 14.8688Z"
        fill="white"
      />
    </svg>
  );
};
export const Taskicon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1538 2.57812H16.2018C15.9478 1.82793 15.2638 1.28906 14.4615 1.28906H13.7407C13.4867 0.538785 12.8023 0 12 0C11.1977 0 10.5133 0.538785 10.2593 1.28906H9.53846C8.73621 1.28906 8.05218 1.82793 7.79815 2.57812H5.84615C4.82818 2.57812 4 3.44554 4 4.51172V20.0664C4 21.1326 4.82818 22 5.84615 22H18.1538C19.1718 22 20 21.1326 20 20.0664V4.51172C20 3.44554 19.1718 2.57812 18.1538 2.57812ZM8.92308 3.22266C8.92308 2.86726 9.19914 2.57812 9.53846 2.57812H10.7692C11.1091 2.57812 11.3846 2.28955 11.3846 1.93359C11.3846 1.5782 11.6607 1.28906 12 1.28906C12.3393 1.28906 12.6154 1.5782 12.6154 1.93359C12.6154 2.28955 12.8909 2.57812 13.2308 2.57812H14.4615C14.8009 2.57812 15.0769 2.86726 15.0769 3.22266V3.86719H8.92308V3.22266ZM18.7692 20.0664C18.7692 20.4218 18.4932 20.7109 18.1538 20.7109H5.84615C5.50683 20.7109 5.23077 20.4218 5.23077 20.0664V4.51172C5.23077 4.15632 5.50683 3.86719 5.84615 3.86719H7.69231V4.51172C7.69231 4.86767 7.96784 5.15625 8.30769 5.15625H15.6923C16.0322 5.15625 16.3077 4.86767 16.3077 4.51172V3.86719H18.1538C18.4932 3.86719 18.7692 4.15632 18.7692 4.51172V20.0664Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M11.2028 11.2318C10.9625 10.98 10.5728 10.98 10.3325 11.2318L8.30614 13.3541L7.51048 12.5208C7.2702 12.2691 6.88054 12.2691 6.64021 12.5208C6.39988 12.7725 6.39988 13.1806 6.64021 13.4323L7.87102 14.7214C7.99114 14.8472 8.14864 14.9101 8.30614 14.9101C8.46363 14.9101 8.62113 14.8472 8.74125 14.7214L11.2028 12.1432C11.4431 11.8915 11.4431 11.4835 11.2028 11.2318Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M11.2028 6.72003C10.9625 6.46832 10.5728 6.46832 10.3325 6.72003L8.30614 8.84239L7.51048 8.00905C7.2702 7.75734 6.88054 7.75734 6.64021 8.00905C6.39988 8.26076 6.39988 8.66884 6.64021 8.92055L7.87102 10.2097C7.99114 10.3355 8.14864 10.3984 8.30614 10.3984C8.46363 10.3984 8.62113 10.3355 8.74125 10.2097L11.2028 7.63153C11.4431 7.37982 11.4431 6.97174 11.2028 6.72003Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M11.2028 15.7435C10.9625 15.4918 10.5728 15.4918 10.3325 15.7435L8.30614 17.8659L7.51048 17.0326C7.2702 16.7809 6.88054 16.7809 6.64021 17.0326C6.39988 17.2843 6.39988 17.6924 6.64021 17.9441L7.87102 19.2331C7.99114 19.359 8.14864 19.4219 8.30614 19.4219C8.46363 19.4219 8.62113 19.359 8.74125 19.2331L11.2028 16.655C11.4431 16.4033 11.4431 15.9952 11.2028 15.7435Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M16.9229 7.82031H13.2306C12.8908 7.82031 12.6152 8.10889 12.6152 8.46484C12.6152 8.8208 12.8908 9.10938 13.2306 9.10938H16.9229C17.2628 9.10938 17.5383 8.8208 17.5383 8.46484C17.5383 8.10889 17.2628 7.82031 16.9229 7.82031Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M16.9229 16.8438H13.2306C12.8908 16.8438 12.6152 17.1323 12.6152 17.4883C12.6152 17.8442 12.8908 18.1328 13.2306 18.1328H16.9229C17.2628 18.1328 17.5383 17.8442 17.5383 17.4883C17.5383 17.1323 17.2628 16.8438 16.9229 16.8438Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M16.9229 12.332H13.2306C12.8908 12.332 12.6152 12.6206 12.6152 12.9766C12.6152 13.3325 12.8908 13.6211 13.2306 13.6211H16.9229C17.2628 13.6211 17.5383 13.3325 17.5383 12.9766C17.5383 12.6206 17.2628 12.332 16.9229 12.332Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
    </svg>
  );
};

export const Pipelineicon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_36266_201943)">
        <path
          d="M8 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H8C9.10457 20 10 19.1046 10 18V6C10 4.89543 9.10457 4 8 4Z"
          stroke={isSelected ? '#1976d2' : '#666666'}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 4H16C14.8954 4 14 4.89543 14 6V12C14 13.1046 14.8954 14 16 14H18C19.1046 14 20 13.1046 20 12V6C20 4.89543 19.1046 4 18 4Z"
          stroke={isSelected ? '#1976d2' : '#666666'}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_36266_201943">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Notesicon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_36490_132601)">
        <path
          d="M6.86538 10.8946C6.86538 10.5634 7.09615 10.3425 7.44231 10.3425H14.8269C15.1731 10.3425 15.4038 10.5634 15.4038 10.8946C15.4038 11.2259 15.1731 11.4467 14.8269 11.4467H7.44231C7.15385 11.4467 6.86538 11.2259 6.86538 10.8946ZM7.44231 14.7591H14.8269C15.1731 14.7591 15.4038 14.5383 15.4038 14.207C15.4038 13.8758 15.1731 13.655 14.8269 13.655H7.44231C7.09615 13.655 6.86538 13.8758 6.86538 14.207C6.86538 14.5383 7.15385 14.7591 7.44231 14.7591ZM7.44231 18.0163H11.8269C12.1731 18.0163 12.4038 17.7955 12.4038 17.4643C12.4038 17.133 12.1731 16.9122 11.8269 16.9122H7.44231C7.09615 16.9122 6.86538 17.133 6.86538 17.4643C6.86538 17.7403 7.15385 18.0163 7.44231 18.0163ZM24 14.4279C24 14.7039 23.8846 14.9799 23.6538 15.2008L15.9231 22.4881C15.8077 22.5985 15.6923 22.6537 15.5769 22.7089L12.4615 23.9235C12.3462 23.9787 11.8269 24.1443 11.3654 23.7027C11.0769 23.4266 10.9615 23.0402 11.1346 22.6537L12.3462 19.6726C12.4038 19.5621 12.4615 19.4517 12.5769 19.3413L18.1154 14.0966V7.41657H15.0577C14.7115 7.41657 14.4808 7.19574 14.4808 6.8645V4.10414H4.90385C4.5 4.10414 4.15385 4.43539 4.15385 4.82184V20.5007C4.15385 20.8871 4.5 21.2183 4.90385 21.2183H9.17308C9.51923 21.2183 9.75 21.4392 9.75 21.7704C9.75 22.1017 9.51923 22.3225 9.17308 22.3225H4.90385C3.86538 22.3225 3 21.4944 3 20.5007V4.82184C3 3.82811 3.86538 3 4.90385 3H15.0577C15.2885 3 15.4038 3.11041 15.4615 3.16562L19.0962 6.47805C19.2692 6.64367 19.2692 6.8645 19.2692 6.8645V12.9925L20.3077 11.9988C20.7692 11.5571 21.4615 11.5571 21.9231 11.9988L23.6538 13.655C23.8846 13.8758 24 14.0966 24 14.4279ZM15.6346 6.31243H17.25L16.9615 6.03639L15.6346 4.82184V6.31243ZM14.4808 21.936L13.2115 20.6663L12.3462 22.7641L14.4808 21.936ZM22.8462 14.3727L21.1154 12.7717L13.8462 19.7278L15.5192 21.384L22.8462 14.3727Z"
          fill={isSelected ? '#1976d2' : '#666666'}
        />
      </g>
      <defs>
        <clipPath id="clip0_36490_132601">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Allicon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 4H8V8H4V4Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M4 10H8V14H4V10Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M8 16H4V20H8V16Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M10 4H14V8H10V4Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M14 10H10V14H14V10Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M10 16H14V20H10V16Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M20 4H16V8H20V4Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M16 10H20V14H16V10Z" fill={isSelected ? '#1976d2' : '#666666'} />
      <path d="M20 16H16V20H20V16Z" fill={isSelected ? '#1976d2' : '#666666'} />
    </svg>
  );
};

export const Agenticon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.56258 12.6866C1.25189 12.6866 1.00003 12.9275 1 13.2247V21.1171C1.00003 21.4142 1.25189 21.6552 1.56258 21.6552H4.18793C4.49862 21.6552 4.75047 21.4142 4.7505 21.1171V14.8391H6.43823C6.61384 14.8391 7.38947 15.13 8.04538 15.4844C9.02016 16.0095 9.32114 16.2509 9.66058 16.3329C10.6683 16.6055 12.1036 16.5836 13.3818 16.775C13.5137 16.9488 13.5653 17.1362 13.5876 17.3503H10.0532C9.29243 17.34 9.29243 18.4368 10.0532 18.4265H14.2044C14.5103 18.4265 14.7602 18.1928 14.767 17.9003C14.7514 16.7967 14.4516 15.8641 13.5466 15.7121C12.1444 15.5021 10.4939 15.4619 9.96678 15.2973C9.78714 15.2412 9.10493 14.8098 8.59916 14.5476C7.90541 14.1728 7.20024 13.7628 6.43823 13.7628H4.18793C3.84403 13.7628 3.62535 14.0373 3.62535 14.3009V20.579H2.12515V13.7628H2.68773C3.44851 13.7731 3.44851 12.6763 2.68773 12.6866H1.56258Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M20.73 16.0341C19.4552 16.1448 17.3782 16.5912 15.8646 16.9372C15.1251 17.0981 15.3905 18.1604 16.1262 17.984C17.5789 17.6519 19.5643 17.2303 20.6919 17.1179C20.8045 17.2926 20.8311 17.3748 20.8634 17.5218C18.4299 18.4247 14.715 20.129 14.5476 20.2059L7.92486 20.5751C7.37127 20.4178 6.79979 20.1706 6.34335 19.9753C5.61078 19.7046 5.22478 20.6992 5.90677 20.9661C6.46589 21.2092 7.08724 21.4602 7.51611 21.5841C7.63727 21.6184 7.7841 21.6593 7.97028 21.6527L14.7212 21.2737C14.7941 21.2696 14.8655 21.252 14.9314 21.2218C14.9314 21.2218 19.101 19.3121 21.4677 18.4521C22.584 18.0235 21.7539 15.9161 20.73 16.0341Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
      <path
        d="M21.2353 7.94118V15.3529H19.2941V8.88L14.1176 5.28529L8.94118 8.88V10.4118H7V7.94118L14.1176 3L21.2353 7.94118ZM15.5671 8.55882H14.5965V9.48529H15.5671V8.55882ZM13.6259 8.55882H12.6553V9.48529H13.6259V8.55882ZM15.5671 10.4118H14.5965V11.3382H15.5671V10.4118ZM13.6259 10.4118H12.6553V11.3382H13.6259V10.4118Z"
        fill={isSelected ? '#1976d2' : '#666666'}
      />
    </svg>
  );
};

export const Solicitoricon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_36266_201938)">
        <path
          d="M12.9999 2V3.278L17.9999 4.946L21.6319 3.736L22.2649 5.632L19.2329 6.643L22.3289 15.155C21.2369 16.292 19.6999 17 17.9999 17C16.2989 17 14.7629 16.292 13.6709 15.155L16.7649 6.643L12.9999 5.387V19H16.9999V21H6.9999V19H10.9999V5.387L7.2319 6.643L10.3279 15.155C9.2369 16.292 7.6999 17 5.9999 17C4.2989 17 2.7629 16.292 1.6709 15.155L4.7649 6.643L1.7349 5.633L2.3679 3.735L5.9999 4.945L10.9999 3.278V2H12.9999ZM17.9999 9.103L16.0419 14.489C16.6289 14.82 17.2989 15 17.9999 15C18.6999 15 19.3699 14.82 19.9579 14.49L17.9999 9.103ZM5.9999 9.103L4.0419 14.489C4.6289 14.82 5.2989 15 5.9999 15C6.6999 15 7.3699 14.82 7.9579 14.49L5.9999 9.103Z"
          fill={isSelected ? '#1976d2' : '#666666'}
        />
      </g>
      <defs>
        <clipPath id="clip0_36266_201938">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Appraisalicon = ({ isSelected }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 22H22"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.9502 22.0003L3.0002 9.97023C3.0002 9.36023 3.2902 8.78029 3.7702 8.40029L10.7702 2.95027C11.4902 2.39027 12.5002 2.39027 13.2302 2.95027L20.2302 8.39028C20.7202 8.77028 21.0002 9.35023 21.0002 9.97023V22.0003"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M10.3359 15.1649C10.3359 15.8099 10.8309 16.3299 11.4459 16.3299H12.7009C13.2359 16.3299 13.6709 15.8749 13.6709 15.3149C13.6709 14.7049 13.4059 14.4899 13.0109 14.3499L10.9959 13.6499C10.6009 13.5099 10.3359 13.2949 10.3359 12.6849C10.3359 12.1249 10.7709 11.6699 11.3059 11.6699H12.5609C13.1759 11.6699 13.6709 12.1899 13.6709 12.8349"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 11V17"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 19C14.7614 19 17 16.7614 17 14C17 11.2386 14.7614 9 12 9C9.23858 9 7 11.2386 7 14C7 16.7614 9.23858 19 12 19Z"
        stroke={isSelected ? '#1976d2' : '#666666'}
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Sortcoloricon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
        fill="#0065FC"
      />
      <path
        d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
        fill="#0065FC"
      />
      <path
        d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
        fill="#0065FC"
      />
      <path
        d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
        fill="#0065FC"
      />
      <rect
        opacity="0.1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

export const SortUpcoloricon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="rotate(180, 16, 21)">
        <path
          d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
          fill="#0065FC"
        />
        <g transform="scale(-1, 1) translate(-31, 0)">
          <path
            d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
            fill="#0065FC"
          />
          <path
            d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
            fill="#0065FC"
          />
          <path
            d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
            fill="#0065FC"
          />
        </g>
      </g>
      <rect
        opacity="0.1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

export const Filtericon = () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.50536 6.52991C8.50536 5.38758 7.52396 4.4576 6.31558 4.4576C5.1085 4.4576 4.12581 5.38758 4.12581 6.52991C4.12581 7.67224 5.1085 8.60221 6.31558 8.60221C7.52396 8.60221 8.50536 7.67224 8.50536 6.52991ZM10.4398 6.52991C10.4398 8.68154 8.59051 10.4329 6.31562 10.4329C4.04201 10.4329 2.19141 8.68154 2.19141 6.52991C2.19141 4.37828 4.04201 2.62695 6.31562 2.62695C8.59051 2.62695 10.4398 4.37828 10.4398 6.52991ZM24.1154 6.53014C24.1154 6.02488 23.682 5.61481 23.1481 5.61481H15.217C14.6831 5.61481 14.2498 6.02488 14.2498 6.53014C14.2498 7.0354 14.6831 7.44547 15.217 7.44547H23.1481C23.682 7.44547 24.1154 7.0354 24.1154 6.53014ZM17.8009 18.6919C17.8009 19.8343 18.7823 20.7642 19.9907 20.7642C21.1991 20.7642 22.1805 19.8343 22.1805 18.6919C22.1805 17.5484 21.1991 16.6196 19.9907 16.6196C18.7823 16.6196 17.8009 17.5484 17.8009 18.6919ZM15.8665 18.6919C15.8665 16.5391 17.7159 14.789 19.9908 14.789C22.2657 14.789 24.115 16.5391 24.115 18.6919C24.115 20.8436 22.2657 22.5949 19.9908 22.5949C17.7159 22.5949 15.8665 20.8436 15.8665 18.6919ZM3.15951 17.7762H11.0894C11.6233 17.7762 12.0566 18.1863 12.0566 18.6916C12.0566 19.1968 11.6233 19.6069 11.0894 19.6069H3.15951C2.62561 19.6069 2.1923 19.1968 2.1923 18.6916C2.1923 18.1863 2.62561 17.7762 3.15951 17.7762Z"
      fill="#0065FC"
    />
  </svg>
);

export const MapIcon = () => (
  <svg
    width="42"
    height="41"
    viewBox="0 0 42 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="40.7967"
      height="39.57"
      rx="4.5"
      stroke="#F0F0F0"
    />
    <path
      d="M20.8984 8.5C25.5288 8.50006 29.2968 12.2681 29.2969 16.8984C29.2968 18.3212 28.8288 19.948 28.0898 21.6191C27.3537 23.2839 26.3644 24.9576 25.3574 26.4648C23.3434 29.4794 21.2848 31.7885 21.1221 31.9697C21.0026 32.1028 20.7934 32.1029 20.6738 31.9697C20.5086 31.7856 18.4521 29.4773 16.4395 26.4648C15.4325 24.9576 14.4432 23.2839 13.707 21.6191C12.9681 19.948 12.5 18.3212 12.5 16.8984C12.5 12.2681 16.268 8.5 20.8984 8.5ZM20.8984 11.9209C18.1537 11.9209 15.9219 14.1537 15.9219 16.8984C15.922 19.6431 18.1537 21.875 20.8984 21.875C23.6431 21.8749 25.8749 19.6431 25.875 16.8984C25.875 14.1537 23.6431 11.921 20.8984 11.9209Z"
      stroke="#2F74EE"
    />
  </svg>
);

export const OpenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 39 38"
      fill="none"
    >
      <circle
        cx="19.5"
        cy="19"
        r="18.5"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5006 17.3465C19.9094 17.3465 20.36 17.5559 20.7184 17.9143C21.0768 18.2727 21.2863 18.7234 21.2863 19.1322C21.2863 19.5409 21.0769 19.9908 20.7187 20.3485C20.3605 20.7061 19.9098 20.9152 19.5006 20.9152C19.0914 20.9152 18.6406 20.7061 18.2824 20.3485C17.9242 19.9908 17.7148 19.5409 17.7148 19.1322C17.7148 18.7234 17.9243 18.2727 18.2827 17.9143C18.6411 17.5559 19.0917 17.3465 19.5006 17.3465ZM19.5006 26.4893C19.9094 26.4893 20.36 26.6988 20.7184 27.0572C21.0768 27.4156 21.2863 27.8662 21.2863 28.275C21.2863 28.6837 21.0769 29.1336 20.7187 29.4913C20.3605 29.849 19.9098 30.0581 19.5006 30.0581C19.0914 30.0581 18.6406 29.849 18.2824 29.4913C17.9242 29.1336 17.7148 28.6837 17.7148 28.275C17.7148 27.8662 17.9243 27.4156 18.2827 27.0572C18.6411 26.6988 19.0917 26.4893 19.5006 26.4893ZM19.5006 8.20361C19.9094 8.20361 20.36 8.41305 20.7184 8.77145C21.0768 9.12985 21.2863 9.58051 21.2863 9.98933C21.2863 10.398 21.0769 10.8479 20.7187 11.2056C20.3605 11.5633 19.9098 11.7724 19.5006 11.7724C19.0914 11.7724 18.6406 11.5633 18.2824 11.2056C17.9242 10.8479 17.7148 10.398 17.7148 9.98933C17.7148 9.58051 17.9243 9.12985 18.2827 8.77145C18.6411 8.41305 19.0917 8.20361 19.5006 8.20361Z"
        fill="black"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 39 38"
      fill="none"
    >
      <circle
        cx="19.5"
        cy="19"
        r="18.5"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.2859 19.1324C21.2859 19.5412 21.0764 19.9919 20.718 20.3503C20.3596 20.7087 19.909 20.9181 19.5001 20.9181C19.0914 20.9181 18.6415 20.7088 18.2839 20.3505C17.9262 19.9923 17.7171 19.5416 17.7171 19.1324C17.7171 18.7232 17.9262 18.2725 18.2839 17.9142C18.6415 17.556 19.0914 17.3467 19.5001 17.3467C19.909 17.3467 20.3596 17.5561 20.718 17.9145C21.0764 18.2729 21.2859 18.7236 21.2859 19.1324ZM12.143 19.1324C12.143 19.5412 11.9336 19.9919 11.5752 20.3503C11.2168 20.7087 10.7661 20.9181 10.3573 20.9181C9.94859 20.9181 9.49869 20.7088 9.14101 20.3505C8.78333 19.9923 8.57422 19.5416 8.57422 19.1324C8.57422 18.7232 8.78333 18.2725 9.14101 17.9142C9.49869 17.556 9.94859 17.3467 10.3573 17.3467C10.7661 17.3467 11.2168 17.5561 11.5752 17.9145C11.9336 18.2729 12.143 18.7236 12.143 19.1324ZM30.4287 19.1324C30.4287 19.5412 30.2193 19.9919 29.8609 20.3503C29.5025 20.7087 29.0518 20.9181 28.643 20.9181C28.2343 20.9181 27.7844 20.7088 27.4267 20.3505C27.069 19.9923 26.8599 19.5416 26.8599 19.1324C26.8599 18.7232 27.069 18.2725 27.4267 17.9142C27.7844 17.556 28.2343 17.3467 28.643 17.3467C29.0518 17.3467 29.5025 17.5561 29.8609 17.9145C30.2193 18.2729 30.4287 18.7236 30.4287 19.1324Z"
        fill="black"
      />
    </svg>
  );
};
export const AgentLicenseIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6"
      y="7"
      width="18"
      height="17"
      rx="2"
      stroke="#112347"
      strokeWidth="1.8"
    />

    <path
      d="M11 7V5.5C11 4.67 11.67 4 12.5 4H17.5C18.33 4 19 4.67 19 5.5V7"
      stroke="#112347"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    <circle cx="11" cy="14" r="2" stroke="#112347" strokeWidth="1.8" />

    <path
      d="M9 20C9.7 17.8 12.3 17.8 13 20"
      stroke="#112347"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    <path
      d="M16 14H21"
      stroke="#112347"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    <path
      d="M16 18H21"
      stroke="#112347"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
